import { Component, Input, ViewChild } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NzCarouselComponent } from 'ng-zorro-antd';
import { FcinputComponent } from '../fcinput';
/**
 * fc-carouselè½®æ­å¾
 * 
 * æè½¬æ¨é©¬ï¼ä¸ç»è½®æ­çåºåã
 * 
 * å½æä¸ç»å¹³çº§çåå®¹ã
 * 
 * å½åå®¹ç©ºé´ä¸è¶³æ¶ï¼å¯ä»¥ç¨èµ°é©¬ç¯çå½¢å¼è¿è¡æ¶çº³ï¼è¿è¡è½®æ­å±ç°ã
 * 
 * å¸¸ç¨äºä¸ç»å¾çæå¡çè½®æ­ã
 * 
 */
@Component({
    selector: 'fc-carousel',
    template: `
    <nz-carousel #nzcarousel class="fc-carousel"
    [ngClass]="{'fc-carousel-small':fcSize === 'small','fc-carousel-default':fcSize === 'default','fc-carousel-large':fcSize === 'large'}"
     [nzAutoPlay]="_autoplay" [nzAutoPlaySpeed]="_speed"
      [nzDots]="_dot" [nzDotPosition]="fcEffect"
        [nzDotPosition]="_vertical">
        <div class="fc-carousel-item" nz-carousel-content *ngFor="let item of fcData">
            <img [src]="item.src" />
            <h3 class="fc-carousel-label">{{item.label}}</h3>
        </div>
    </nz-carousel>
    `,
    styles: [`
    .fc-carousel .slick-slide {
        width:100%;
        text-align: center;
        height: 160px;
        line-height: 160px;
        background: #364d79;
        color: #fff;
        overflow: hidden;
        position:relative;
    }
    .fc-carousel .slick-slide img{
        width:100%;
        height:100%;
    }
    .fc-carousel-item {
        width:100%;
        height:100%;
        text-align: center;
    }
    .fc-carousel-label {
        width:100%;
        color: #fff;
        text-align:center;
        position:absolute;
        left:0;
        top:0;
    }
    `]
})
export class FccarouselComponent extends FcinputComponent {
     /**æ°å¼*/
    @Input()
    fcData: any[];
    @ViewChild('nzcarousel', {static: false})
    _nzcarousel: NzCarouselComponent;
    _fcSlickGoTo: number;
     /**åæ¢å°æå®ç´¢å¼é¢æ¿*/
    @Input()
    fcSlickGoTo: string;
      /**åç´æ­æ¾*/
     @Input()
    fcVertical:string;
    _vertical:boolean;
     /**åç´æ­æ¾*/
    @Input()
    fcEffect:string;
     /**åç´æ­æ¾*/
    @Input()
    fcDots:string;
    _dot:boolean;
     /**æ­æ¾éåº¦*/
    @Input()
    fcAutoPlaySpeed:string;
    _speed :number;
     /**èªå¨æ­æ¾*/
    @Input()
    fcAutoPlay:string;
    _autoplay:boolean;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-carousel'); 
    }
    _afterParentInit() {
        if (this.fcSlickGoTo) {
            this._nzcarousel.goTo(Number.parseInt(this.fcSlickGoTo));
        }
         /**å¤æ­æ¯å¦åç´æ­æ¾å¦æç­äºYåç´æ­æ¾*/
        this._vertical = this.fcVertical === 'Y'?true:false;
         /**å¤æ­æ¯å¦ç¹å»æ­æ¾å¦æç­äºYç¹å»æ­æ¾*/
        this._dot = this.fcDots === 'Y'?true:false;
         /**å¤æ­æ¯å¦èªå¨æ­æ¾å¦æç­äºYèªå¨æ­æ¾*/
        this._autoplay = this.fcAutoPlay === 'Y'?true:false;
         /**è®¾ç½®æ­æ¾éåº¦å°å­ç¬¦ä¸²ä¸ç¨number*/
        this._speed = this.fcAutoPlaySpeed !== undefined?Number.parseInt(this.fcAutoPlaySpeed):3000;
         /**è®¾ç½®æ­æ¾ææå¦æä¸ºç©ºæ­æ¾æææªscrollx*/
        this.fcEffect=this.fcEffect?this.fcEffect:'scrollx';
    }
}